import * as responseRate from '../../../apis/responseRate'
import { createSelector } from 'reselect'

const FETCH_INITIAL_CHART_REQUESTED = 'FETCH_INITIAL_CHART_REQUESTED'
const FETCH_INITIAL_CHART_SUCCESS = 'FETCH_INITIAL_CHART_SUCCESS'
const FETCH_INITIAL_CHART_FAILED = 'FETCH_INITIAL_CHART_FAILED'

export const fetchInitialChart = (circleId, caseId, protocolId, languageId) => (dispatch) => {
	dispatch({ type: FETCH_INITIAL_CHART_REQUESTED, data: { isLoading: true, showSample: false } })
	responseRate.fetchInitialChart(circleId, caseId, protocolId, languageId).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({
				type: FETCH_INITIAL_CHART_SUCCESS,
				data: response,
				isLoading: false,
				showSample: false
			})
		} else if(!response || !response.redirectTo) {
			return dispatch({
				type: FETCH_INITIAL_CHART_FAILED,
				data: { isLoading: false, showSample: true }
			})
		}
	})
}


const MARK_SCORES_AS_READ_REQUESTED = 'MARK_SCORES_AS_READ_REQUESTED'
const MARK_SCORES_AS_READ_SUCCESS = 'MARK_SCORES_AS_READ_SUCCESS'
const MARK_SCORES_AS_READ_FAILED = 'MARK_SCORES_AS_READ_FAILED'

export const markScoresAsRead = (patientId, caseId, scoringGroupId) => (dispatch) => {
	dispatch({ type: MARK_SCORES_AS_READ_REQUESTED, data: { isLoading: true, showSample: false } })
	responseRate.markScoresAsRead(patientId, caseId, scoringGroupId).then((response) => {
		if (response && response.isSuccessful) {
			return dispatch({
				type: MARK_SCORES_AS_READ_SUCCESS,
				data: {}
			})
		} else if(!response || !response.redirectTo) {
			return dispatch({
				type: MARK_SCORES_AS_READ_FAILED,
				data: {}
			})
		}
	})
}

const initial = {
	tabs: [],
	chart: null,
	schema: [],
	hasScoringGroups: false,
	isLoading: false,
	showSample: false,
	benchmarcs: []
}

export const reducer = (state = initial, action) => {
	switch (action.type) {
		case FETCH_INITIAL_CHART_REQUESTED:
			return {
				...state,
				//schema: null,
				isLoading: action.data.isLoading,
				showSample: action.data.showSample
			}
		case FETCH_INITIAL_CHART_SUCCESS:
			return {
				...state,
				schema: action.data.schema,
				benchmarcs: action.data.benchmarcs,
				hasScoringGroups: action.data.hasScoringGroups,
				isLoading: action.data.isLoading,
				showSample: action.data.showSample
			}

		case FETCH_INITIAL_CHART_FAILED:
			return {
				...state,
				schema: null,
				benchmarcs: null,
				hasScoringGroups: false,
				isLoading: action.data.isLoading,
				showSample: action.data.showSample
			}
		case 'SIGN_OUT_REQUESTED':
			return initial
		default:
			return { ...state }
	}
}

const mainSelector = (state) => state.chart

export const benchmarcsSelector = createSelector(mainSelector, (state) => {
	if (state && state.benchmarcs && state.benchmarcs.length > 0) return state.benchmarcs
	else return 0
})

export const schemaSelector = createSelector(mainSelector, (state) => {
	if (state && state.schema && state.schema.length > 0) return state.schema
	else return 0
})

export const hasScoringGroupsSelector = createSelector(mainSelector, (state) => {
	return state && state.hasScoringGroups
})

export const isLoadingSelector = createSelector(mainSelector, (state) => {
	if (state) return state.isLoading
})

export const showSampleSelector = createSelector(mainSelector, (state) => {
	if (state) return state.showSample
})

export const tabsSchemaSelector = createSelector(mainSelector, (state) => {})

export const sampleDataSelector = createSelector(mainSelector, (state) => {
	return [
		{
			scoringGroupId: 1,
			scoringGroupName: 'Sample Results',
			minScore: 0,
			maxScore: 100,
			coordinates: [
				{
					xAxis: 0,
					labelValue: 0,
					labelUnit: 0,
					labelTreatmentPhaseId: 0,
					myScore: 30,
					allPatientsCircleScore: 20,
					completionDate: '2020/01/01'
				},
				{
					xAxis: 1,
					labelValue: 0,
					labelUnit: 0,
					labelTreatmentPhaseId: 1,
					myScore: 40,
					allPatientsCircleScore: 50,
					completionDate: '2020/02/01'
				},
				{
					xAxis: 2,
					labelValue: 1,
					labelUnit: 2,
					labelTreatmentPhaseId: 2,
					myScore: 65,
					allPatientsCircleScore: 55,
					completionDate: '2020/03/01'
				},
				{
					xAxis: 3,
					labelValue: 2,
					labelUnit: 2,
					labelTreatmentPhaseId: 2,
					myScore: 60,
					allPatientsCircleScore: 50,
					completionDate: '2020/04/01'
				},
				{
					xAxis: 4,
					labelValue: 3,
					labelUnit: 2,
					labelTreatmentPhaseId: 2,
					myScore: 65,
					allPatientsCircleScore: 55,
					completionDate: '2020/05/01'
				},
				{
					xAxis: 5,
					labelValue: 4,
					labelUnit: 2,
					labelTreatmentPhaseId: 2,
					myScore: 75,
					allPatientsCircleScore: 65,
					completionDate: '2020/06/01'
				}
			]
		}
	]
})
